import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import styled from 'styled-components';
import { Scheme, Size } from '../../Constants/System';
import { Typography } from '../../Constants/Typography';
import { mergeWithDefaults } from '../../Utility/PropUtils';
const LinkDefaultProps = {
    size: Size.medium,
    scheme: Scheme.brand1,
};
const Link = forwardRef((props, ref) => {
    const propsWithDefaults = mergeWithDefaults(props, LinkDefaultProps);
    // There is no primary (it is actually just the brancd colour instead)
    const actualScheme = propsWithDefaults.scheme === Scheme.primary ? Scheme.brand1 : propsWithDefaults.scheme;
    return _jsx(StyledLink, { ...propsWithDefaults, scheme: actualScheme, ref: ref });
});
Link.displayName = 'Link';
export default Link;
const StyledLink = styled.a `
	cursor: pointer;
	color: ${(props) => props.theme.schemes[props.scheme].passive};
	font-family: Lato, sans-serif;
	font-size: ${(props) => SizeMap[props.size]};
	text-decoration: none;

	&:hover {
		text-decoration: underline;
	}

	&:focus {
		box-shadow: inset 0px 0px 0px 2px ${(props) => props.theme.palette.brand1};
	}

	&:visited {
		color: ${(props) => props.theme.schemes[props.scheme].active};
		opacity: 0.8px;
	}
`;
const SizeMap = {
    [Size.small]: Typography.sm,
    [Size.medium]: Typography.md,
    [Size.large]: Typography.lg,
};
//# sourceMappingURL=Link.js.map